import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

// Only for admin users
export const approveProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${productId}/aprobar`
  );
export const deniedProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/productos/${productId}/rechazar`
  );

export const getTenant = async (dominio: string) =>
  await axiosInstanceMain.get(`/tenants?dominio=${dominio}`);
